import Input from './BaseInput';
import TextArea from './TextArea';
import Search from './Search';
import Password from './Password';

Input.TextArea = TextArea;
Input.Search = Search;
Input.Password = Password;

export default Input;
